/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWineBarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-wine-bar"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.68 19.15L10.68 15.55Q8.5 15.1 6.85 13.2Q5.2 11.3 5.2 9L5.2 3.52Q5.2 2.98 5.59 2.59Q5.97 2.2 6.53 2.2L17.48 2.2Q18.02 2.2 18.41 2.59Q18.8 2.98 18.8 3.52L18.8 9Q18.8 11.3 17.15 13.2Q15.5 15.1 13.32 15.55L13.32 19.15L15.47 19.15Q16.02 19.15 16.41 19.54Q16.8 19.93 16.8 20.48Q16.8 21.02 16.41 21.41Q16.02 21.8 15.47 21.8L8.53 21.8Q7.97 21.8 7.59 21.41Q7.2 21.02 7.2 20.48Q7.2 19.93 7.59 19.54Q7.97 19.15 8.53 19.15ZM7.85 7.67L16.15 7.67L16.15 4.85L7.85 4.85Z" fill={color} />
    </svg>
  );
}
